<template>
  <v-container grid-list-xl>
    <v-row wrap>
      <v-col cols="12">
        <v-alert dense text class="body-2 mt-5" type="info">
          <b>Mutasi Masuk</b> adalah proses mutasi pegawai yang selesai atay dalam proses dari instansi luar ke instansi
          Anda. Sendangkan <b>Mutasi Keluar</b> adalah proses mutasi pegawai yang selesai atau dalam proses dari
          instansi Anda ke instansi luar
        </v-alert>
      </v-col>
      <v-col cols="12">
        <m-card-list
          title="Mutasi Pegawai"
          label-cari="Cari Pegawai"
          :add="isCan('mutasi.store')"
          search
          refresh
          :items="items"
          :headers="headers"
          @search="
            (search) => {
              textSearch = search
              load()
            }
          "
          :page="page"
          @change:page="
            (pg) => {
              cp = pg
              load()
            }
          "
          @refresh="load()"
          @add="add"
          footer
        >
          <template v-slot:filter>
            <v-tabs class="mt-5" v-model="tab">
              <v-tab>Mutasi Masuk</v-tab>
              <v-tab>Mutasi Keluar</v-tab>
            </v-tabs>
          </template>
          <template v-slot:items="{ item }">
            <tr>
              <td>
                <v-row wrap class="pt-5">
                  <v-col cols="3" align="center" justify="center">
                    <v-avatar :size="35" color="grey lighten-4 mr-2">
                      <img :src="'img/cowok.png'" alt="avatar" />
                    </v-avatar>
                  </v-col>
                  <v-col cols="9">
                    <p class="font-weight-bold my-0 py-0"> {{ pVal(item.users, 'nama') }} </p>
                    <p class="grey--text caption"> {{ pVal(item.users, 'email') }} </p>
                  </v-col>
                </v-row>
              </td>
              <td>
                {{ getDeepObj(item, 'organisasi_tujuan.nama') || getDeepObj(item, 'organisasi_asal.nama') || '' }}
              </td>
              <td>
                <v-chip :color="mStatus[item.k_status]['color']" outlined small>
                  {{ getDeepObj(item, 'm_status.status').toLocaleLowerCase() }}
                </v-chip>
              </td>
              <td>
                <div>{{ getDeepObj(item, 'users_verval.nama') || getDeepObj(item, 'users_ajuan.nama') }}</div>
                <div
                  v-if="getDeepObj(item, 'users_verval.nama') || getDeepObj(item, 'users_ajuan.nama')"
                  class="grey--text caption"
                  >{{ getDeepObj(item, 'wkt_mutasi') | toSDNF }}</div
                >
              </td>
              <td>
                <v-btn color="primary" depressed small @click="onDetail(item)">
                  <v-icon left>mdi-magnify</v-icon> Periksa
                </v-btn>
              </td>
            </tr>
          </template>
        </m-card-list>
      </v-col>
    </v-row>
    <FormMutasi
      ref="form"
      :users="user"
      :organisasis="organisasi"
      :tenants="tenants"
      :progress="userProgress"
      @refresh="load"
      @getUser="loadUsers"
    ></FormMutasi>
    <FormKonfirmasi ref="konfirmasi" @refresh="load" is-tenant></FormKonfirmasi>
  </v-container>
</template>
<script>
import FormMutasi from '../components/FormTenant.vue'
import FormKonfirmasi from '../components/Konfirmasi'
import { M_STATUS } from '@/modules/mutasi/const'
export default {
  components: { FormMutasi, FormKonfirmasi },
  data() {
    return {
      title: null,
      items: [],
      page: null,
      cp: 1,
      kuota: null,
      textSearch: '',
      tab: 0,
      headers: [
        { text: 'Anggota', align: 'left', value: 'nama', sortable: false },
        {
          text: 'Organisasi Tujuan',
          align: 'left',
          value: 'is_face_verified',
          sortable: false,
        },
        { text: 'Status', align: 'left', value: 'k_status', sortable: false },
        { text: 'Disetujui Oleh', align: 'left', value: 'verval', sortable: false },
        { text: '', align: 'center', sortable: false },
      ],
      more_menu: [
        // eslint-disable-next-line
        {
          title: 'Detail',
          click: () =>
            this.$router.push({
              name: 'user.detail',
              params: {},
            }),
        },
      ],
      user: [],
      tenants: [],
      organisasi: [],
      userProgress: [],
      mStatus: M_STATUS,
    }
  },
  activated() {
    this.reset()
    this.load()
    this.loadOrganisasis()
    this.loadDaftarTenant()
    this.loadUserKeluar()
  },
  methods: {
    reset() {
      this.items = []
      this.organisasi = []
      this.user = []
    },

    add() {
      this.$refs.form.open()
    },

    loadUserKeluar() {
      this.$store
        .dispatch('mutasi/fetchTenant', {
          no_reg: this.current_user.kode_tenant,
          api: 'mutasi-keluar',
          params: {},
        })
        .then((res) => {
          const items = res.data.data || []
          this.userProgress = items.filter((s) => Number(s.k_status) === 4).map((item) => item.user_id)
        })
        .catch((e) => e)
    },

    load() {
      this.$store
        .dispatch('mutasi/fetchTenant', {
          no_reg: this.current_user.kode_tenant,
          api: Number(this.tab) === 0 ? 'mutasi-masuk' : 'mutasi-keluar',
          params: {
            page: this.cp,
            keyword: this.textSearch,
          },
        })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },

    loadUsers(id) {
      this.$store
        .dispatch('mutasi/getUsers', {
          organisasi_id: id,
          params: { count: 500, is_aktif: 1 },
        })
        .then(({ data }) => {
          this.user = data || []
        })
    },

    loadOrganisasis() {
      this.$store
        .dispatch('organisasi/get', {
          count: 100,
          kode_tenant: this.tenant_id,
        })
        .then(({ data }) => {
          this.organisasi = ((data && data.data) || []).filter((s) => s.kode_organisasi !== this.organisasi_id)
        })
    },

    loadDaftarTenant() {
      this.$store
        .dispatch('tenant/getKoneksi', {
          no_reg: this.current_user.kode_tenant,
          params: {
            count: 100,
          },
        })
        .then(({ data }) => {
          this.tenants = data.data || []
        })
    },

    isOrganisasiAsal(id) {
      return Number(this.current_organisasi && this.current_organisasi.organisasi_id) === Number(id)
    },

    getOrganisasi(id) {
      return (this.organisasi || []).find((s) => s.organisasi_id === Number(id)) || {}
    },

    async onDetail(item) {
      let resp = await this.$store
        .dispatch('mutasi/getDetailTenant', {
          no_reg: this.current_user.kode_tenant,
          id: item.mutasi_id,
        })
        .then(({ data }) => data)

      this.$refs.konfirmasi.open(Object.assign({}, resp, { is_asal: +this.tab === 1 }))
    },
    onChangeTab() {
      this.page = {}
      this.keyword = ''
      this.load()
    },
  },
  watch: {
    tab: 'onChangeTab',
  },
}
</script>
